import {http} from './config';
export default {
    index(filter, page){
        return http.get(`api/v1/configAreaPublica?page=${page}`);
    },
    getAllCompany(){
        return http.get('api/v1/configAreaPublica/companhiasQueUsuarioAdministra');
    },
    create(data){
        return http.post('api/v1/configAreaPublica', data);
    },
    edit(id, data){
        return http.put(`api/v1/configAreaPublica/${id}`, data);
    }
}